
import VerifyWarriorsWallet from '~/components/auth/VerifyWallet';
import BattleNavTournament from '~/components/war/battle/BattleNavTournament';
import { useGameAuthentication } from '~/contextProviders/GameAuthenticationProvider';
import { useGameContext } from '~/contextProviders/GameContextProvider';
import { useGetAccount } from '~/hooks/web3/useGetAccount';
import { generateMatchups } from '~/utils/utils';

import MainNav from '../navbar/MainNav';
import Battle from './battle/Battle';
import BattleHero from './battle/BattleHero';

export default function Layout({ children }) {
  const { battle, playMusic, ownerPairings } = useGameContext();
  const { accessToken } = useGameAuthentication();
  const { data: connectedAccount } = useGetAccount();
  let matchups = [];
  if (ownerPairings && !!ownerPairings.length && connectedAccount?.address) {
    matchups = generateMatchups(connectedAccount?.address, ownerPairings);
  }
  return (
    <div className="container container--battle">
      <header className="landing-page__header">
        <MainNav showConnectWallet={true} playMusic={playMusic} />
      </header>
      {/* Attempt at fixing layout shift but causing logo to be hidden */}
      <div
        className={`content-wrapper content-wrapper--hidden ${
          matchups.length ? '' : 'content-wrapper--small'
        } `}
      >
        <BattleHero />
        <BattleNavTournament />
        {!accessToken && <VerifyWarriorsWallet />}
        <Battle battle={battle}>{children}</Battle>
      </div>
    </div>
  );
}
